import { callApi } from './api'
import { ALIADA } from './schemas'
import * as qs from 'utils/querystring'

export function search (querystring) {
  const endpoint = querystring ? `aliadas${querystring}` : 'aliadas'
  const config = {
    requiresAuth: true
  }
  return callApi(endpoint, config)
}

export function fetch (id, queryobject) {
  const hasQueryobject = queryobject && Object.keys(queryobject).length > 0
  const querystring = hasQueryobject
    ? qs.stringify(queryobject)
    : ''

  const endpoint = `aliadas/${id}${querystring}`
  const config = {
    requiresAuth: true
  }
  return callApi(endpoint, config, ALIADA)
}

export function getServiceCost (aliadaId, queryobject) {
  const querystring = qs.stringify(queryobject)
  const endpoint = `aliadas/${aliadaId}${querystring}`
  const config = {}

  return callApi(endpoint, config).then(({ response }) => response.serviceCost)
}

export function availability(querystring) {
  const endpoint = `aliadas/availability${querystring}`
  const config = {}

  return callApi(endpoint, config).then(({response}) => response.results)
}



// WEBPACK FOOTER //
// ./src/services/api/aliadas.js